import {Post} from './Post';

export const PostRoutes = {
  [Post.SignIn]: '/api/v1/users/sign_in',
  [Post.DeleteAccount]: '/api/v1/gdpr/delete_account',
  [Post.CreateCompanyLocations]: (companyResourceId: string) => `/api/v1/companies/${companyResourceId}/locations`,
  [Post.AddMatchTags]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_tags`,
  [Post.RequestPasswordReset]: '/api/v1/users/password/reset',
  [Post.SecureObjectUpload]: '/api/v1/secure_object_uploads',
  [Post.SecureObjectDelete]: '/api/v1/secure_object_deletion',
  [Post.CreateApplicantSkills]: '/api/v1/applicant_skills',
  [Post.CreateCultureSurvey]: (companyId: string) => `/api/v1/companies/${companyId}/surveys`,
  [Post.CreateCompanyDepartments]: (companyId: string) => `/api/v1/companies/${companyId}/departments`,
  [Post.CreateCompanySubdepartments]: (companyId: string, departmentId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/subdepartments`,
  [Post.CreateCompanyBenefits]: (companyId: string) => `/api/v1/companies/${companyId}/benefits`,
  [Post.VerifyUser]: (userId: string, authToken: string) => `/api/v1/users/${userId}/verify/${authToken}`,
  [Post.ResendVerificationEmail]: '/api/v1/users/resend_registration_confirmation_email',
  [Post.CreateCompanyAdmin]: (companyId: string) => `/api/v1/companies/${companyId}/admins`,
  [Post.CreateMatchComment]: (companyId: string, matchId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_comments`,
  [Post.CreateExternalApplicant]: (companyId: string) => `/api/v1/companies/${companyId}/screening_applicants`,
  [Post.ValidateScreeningApplicantBatchInvitations]: (companyId: string) =>
    `/api/v1/companies/${companyId}/screening_applicants/batch_invitations_validate`,
  [Post.ConfirmScreeningApplicantBatchInvitations]: (companyId: string) =>
    `/api/v1/companies/${companyId}/screening_applicants/batch_invitations_confirm`,
  [Post.ResendExternalApplicantInvitation]: (companyId: string, applicantId: string) =>
    `/api/v1/companies/${companyId}/screening_applicants/${applicantId}/resend_invitation`,
  [Post.SendCompleteSurveyToApplicant]: '/api/v1/talent_survey_requests',
  [Post.GenerateCampaignToken]: (campaignId: string) => `/api/v1/marketing_campaigns/${campaignId}/generate_token`,
  [Post.CreateTalentSurvey]: '/api/v1/talent_surveys',
  [Post.GenerateNewQuestionnaire]: '/api/v1/public/company_survey_questionnaires',
  [Post.CreateCompanySurvey]: (companyId: string) => `/api/v1/companies/${companyId}/surveys`,
  [Post.UploadDocuments]: '/api/v1/applicant_documents',
  [Post.SubmitLightCompanySurveyResults]: '/api/v1/light_company_surveys/results',
  [Post.CreateTalentPoolMatch]: (companyId: string) => `/api/v1/companies/${companyId}/talent_pool/match`,
  [Post.AssignDepartmentTargetProfile]: (companyId: string, departmentId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/target_profiles`,
  [Post.AddDepartmentTargetProfileSkill]: (companyId: string, departmentId: string, profileId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/target_profiles/${profileId}/skills`,
  [Post.CreateCompanyWorkforceProfile]: (companyId: string) => `/api/v1/companies/${companyId}/workforce_profiles`,
  [Post.ResearchWorkforceProfileDraft]: (companyId: string) =>
    `/api/v1/companies/${companyId}/workforce_profiles/research_draft`,
  [Post.ReanalyseCompanyWorkforceProfile]: (companyId: string, profileId: string) =>
    `/api/v1/companies/${companyId}/workforce_profiles/${profileId}/reanalyse`,
  [Post.CreateOtp]: '/api/v1/users/otp',
  [Post.ValidateOtp]: '/api/v1/users/otp/validate',
};
